<form id="ad-comprobante" class="row form-address-styles first-container-identification-xs m-t-34 m-t-xs-40 m-b-29 form-width-size" [formGroup]="form" (ngSubmit)="saveStepOne($event)" autocomplete="off">
  <div class="  col-12 m-b-36 d-flex justify-content-between align-items-start">
    <div class="container-return-style align-self-start">
      <img class="img-return-blue" [src]="url_img.return_blue" alt="" (click)="previous('I')">
    </div>
    <app-header-steps></app-header-steps>
  </div>
  <div class="col-12 m-b-40 m-b-xs-20">
    <div class="">
      <div class="d-block w-100">
        <p class=" heading-b-m-24 text-start line-height-20 text-start m-b-20">
          Adjunta un comprobante de domicilio
        </p>

        <p class=" paragraph-b-r-16 text-start line-height-20 m-b-8">
          Puede ser el recibo de la luz, agua, teléfono fijo o un estado de cuenta bancaria con vigencia no mayor a tres
          meses.
        </p>
      </div>
    </div>
  </div>

  <div class="col-12 ">
    <div class=" input-error-style" [ngClass]="{'input-error-style': proofAddressName.invalid && proofAddressName.touched }">
      <p class=" paragraph-b-r-16 text-start line-height-20 m-b-16">
        ¿El comprobante está a tu nombre?
      </p>
      <div class="form-check form-check-inline radio-style-form m-b-5">
        <label class="form-check-label radio-content " for="proof_address_name1">Sí
          <input class="form-check-input" type="radio" formControlName="proof_address_name" id="proof_address_name1" value="1">
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="form-check form-check-inline radio-style-form m-b-5">
        <label class="form-check-label radio-content " for="proof_address_name2">No
          <input class="form-check-input" type="radio" formControlName="proof_address_name" id="proof_address_name2" value="0">
          <span class="checkmark"></span>
        </label>
      </div>
      <p class="text-error-style d-flex align-items-center" *ngIf="proofAddressName.invalid && proofAddressName.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="" >Elige una opción para continuar
      </p>
    </div>
  </div>

  <div class="w-100 d-block"></div>
  <div class="col-12 m-b-40">

    <div [hidden]="showTextTypeProof('1')">
      <p class=" paragraph-b-r-16 text-start line-height-20 m-b-20">
        Adjunta una imagen de tu comprobante de domicilio. Debe ser PNG, JPG o PDF y pesar menos de 5MB.
      </p>
    </div>

    <div [hidden]="showTextTypeProof('0')">
      <p class=" paragraph-b-r-16 text-start line-height-20 m-b-20">
        Adjunta una imagen de tu comprobante de domicilio.
      </p>
      
      <div class="container-list-text m-b-20">
        <div class="d-flex flex-row justify-content-start align-items-start m-b-24">
          <div class="check-list-icon"><img class="img-check-blue" [src]="url_img.check_blue" alt=""></div>
          <div class="check-list-text">
            <p class="paragraph-b-r-16 mb-0">Debe ser PNG, JPG o PDF y pesar menos de 5MB </p>
          </div>
        </div>
        <div class="d-flex flex-row justify-content-start align-items-start m-b-24">
          <div class="check-list-icon"><img class="img-check-blue" [src]="url_img.check_blue" alt=""></div>
          <div class="check-list-text">
            <p class="paragraph-b-r-16 mb-0">Debe mostrar escrita a mano la leyenda “Bajo protesta de decir verdad indico que he vivido un periodo de
              ___________________________ en
              este domicilio y mi relación con el titular es ___________________________.” </p>
          </div>
        </div>
        <div class="d-flex flex-row justify-content-start align-items-start">
          <div class="check-list-icon"><img class="img-check-blue" [src]="url_img.check_blue" alt=""></div>
          <div class="check-list-text">
            <p class="paragraph-b-r-16 mb-0">Debe mostrar tu firma y la fecha de hoy
            </p>
          </div>
        </div>
      </div>
    </div>

    <div [ngClass]="{'input-error-style': invalidSizeFile || invalidExtFile || invalidNameFile || msgErrorFile!=''}" [hidden]="showInputFile()">
      <div class="input-dropzone-style width-200 m-b-5" >
        <input type="file" class="form-control input-custom-file" formControlName="file_proof" #file_proof (change)="uploadFileAddress($event)" accept=".png,.jpg,.pdf">
        <p class="text-dropzone-style"> Seleccionar archivo</p>
      </div>
      <p class="text-error-style d-flex align-items-center" *ngIf="invalidSizeFile">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">El archivo debe pesar menos de 5MB
      </p>
      <p class="text-error-style d-flex align-items-center" *ngIf="invalidExtFile">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">El archivo debe ser PNG, JPG o PDF
      </p>
      <p class="text-error-style d-flex align-items-center" *ngIf="invalidNameFile">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">El nombre del archivo deber ser menor a 50 caracteres
      </p>
      <p class="text-error-style d-flex align-items-center" *ngIf="msgErrorFile!=''">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">{{msgErrorFile}}
      </p>
    </div>

    <div [hidden]="showFile()">
      <div class="container-photo-style m-b-16" [hidden]="showImgPdf('img')">
        <img class="img-id-front" [src]="dataTypeAddress.file_base64" alt="">
        <img class="img-arrows-white" [src]="url_img.arrows_white" alt="" (click)="openModal(content)">
      </div>
    
      <div class="container-pdf-style m-b-16" [hidden]="showImgPdf('pdf')">
        <img class="img-pdf-blue" [src]="url_img.pdf_blue" alt="">
        <span class="text-pdf-blue p-l-10">
          <span class="">{{dataTypeAddress.cx_nombre_documento}}</span>
        </span>
      </div>

      <a class="link-generic-style line-height-20 m-b-5 d-block" href="javascript:void(0)" (click)="file_proof.click()">Reemplazar</a>
    </div>

  </div>

  <div class="col-12 m-b-40">

    <div class="container-bottom-dynamic" [ngClass]="{'input-error-style': (radioTypeAddress.invalid && radioTypeAddress.touched) || ((selectTypeAddress.invalid && selectTypeAddress.touched)) }">
      <p class=" paragraph-b-r-16 text-start line-height-20 m-b-16">
        Mi domicilio es:
      </p>
      <div class="form-check  radio-style-form radio-repet-bottom" *ngFor="let item of typesAddressRadio">
        <label class="form-check-label radio-content " for="radio_type_address_{{item.idTipoDom}}"><span class="first-letter-capitalize">{{item.tipoDom |titlecase}}</span>
          <input class="form-check-input" type="radio" formControlName="radio_type_address" id="radio_type_address_{{item.idTipoDom}}" [value]="item.idTipoDom" (change)="setRequiredOptions()">
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="form-check  radio-style-form m-b-5">
        <label class="form-check-label radio-content " for="radio_type_address">
          <select class="paragraph-b-r-16 select-field-style width-240" formControlName="select_type_address" id="select_type_address" (change)="setAnotherOption()">
            <option value="">Elige otro</option>
            <option *ngFor="let option of typesAddressOption" value="{{option.idTipoDom}}">{{option.tipoDom |titlecase}}</option>
          </select>
          <!--?Nuevo select para verlo regresar a d-block la clase d-none-->
          <div ngbDropdown class="button-dropdown-style d-none w-240">
            <div class="button-generic-style button-outline button-drop-style text-start width-240 height-40 d-flex justify-content-between align-items-center p-y-11" id="dropdownBasic1" ngbDropdownToggle> 
              <span>Elige otro</span> <img class="img-arrowdown-blue" src="assets/img/img-arrowdown-blue.svg" alt="">
            </div>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-container-style">                
              <button ngbDropdownItem>Another Action</button>
              <button ngbDropdownItem>Something else is here</button>
            </div>
          </div>
          <input class="form-check-input" type="radio" formControlName="radio_type_address" id="radio_type_address" [value]=0 (change)="setRequiredOptions()">
          <span class="checkmark top-10"></span>
        </label>
      </div>
      <p class="text-error-style d-flex align-items-center" *ngIf=" (radioTypeAddress.invalid && radioTypeAddress.touched) || (selectTypeAddress.invalid && selectTypeAddress.touched)">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">Elige una opción para continuar
      </p>
    </div>

  </div>

  <div class="col-6  text-start">
    <div class="m-b-29">
      <button class="button-generic-style button-outline height-48 font-robo-m w-100" (click)="previous('')">Regresar</button>
    </div>
  </div>
  <div class="col-6  text-end">
    <div class="m-b-29">
      <button class="button-generic-style button-blue height-48 font-robo-m w-100" [disabled]="form.invalid">Continuar</button>
    </div>
  </div>
</form>

<ng-template #content let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Close')">
      <img class="img-close-blue" [src]="url_img.close_blue" alt="">
    </button>
  </div>
  <div class="modal-body text-center">
    <img class="img-fluid" [src]="dataTypeAddress.file_base64" alt="">
  </div>
</ng-template>
